export default __webpack_public_path__ + "static/media/Video2.8b2726ac.mp4";